<template>
    <v-select :items="leasingItems" :value="value" @input="syncValue" label="Leasingbil" hide-details/>
</template>

<script>

export default {
    props: {
        value: {
            type: Number
        },
    },
    methods: {
        syncValue(value) {
            this.$emit('input', value);
        }
    },
    computed: {
        leasingItems() {
            return [
                {value: null, text: 'Alle'},
                {value: true, text: 'Kun leasingbiler'},
                {value: false, text: 'Ikke leasingbiler'}
            ]
        },
    }
}
</script>

<style scoped>

</style>
